import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ValidationHttpErrorResponse } from '../models/models';
import { StatusCodes } from './status-codes.enum';
import { ToasterService } from '../shared/components/toaster-widget/toaster.service';
import { ToastType } from '../shared/components/toaster-widget/toaster-widget.component';
import { SESSION_STORAGE } from '../shared/injections/window';
import { SendEventHelper } from '@libs/helpers/send-event.helper';
import { ErrorEnum } from '@libs/enums/error.enam';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private toaster: ToasterService,
    private eventHelper: SendEventHelper,
    @Inject(SESSION_STORAGE) private sessionStorage: Storage,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const skipErrorInterceptor: boolean | null = JSON.parse(req.headers.get('skipErrorInterceptor'));
        if (err.error instanceof ErrorEvent) {
          console.log('error.browser');
        }
        if (err.error instanceof Blob) {
          this.convertBlobError(err.error).subscribe((convertedErr) => {
            this.toaster.showWithContent(ToastType.WARNING, {
              title: 'errors.title',
              message: convertedErr.message,
              loggerCode: convertedErr.loggerCode,
            });
          });
          this.sendError(err.message);
          return throwError(err);
        }

        if (skipErrorInterceptor) {
          return throwError(() => err);
        }

        switch (err.status) {
          case StatusCodes.CONNECTION_REFUSED:
            break;
          case StatusCodes.UNAUTHORIZED:
            break;
          case StatusCodes.BAD_REQUEST:
            const errors = (err.error as ValidationHttpErrorResponse).fieldErrors;
            this.toaster.showWithContent(ToastType.WARNING, {
              title: 'errors.title',
              errors,
            });
            this.sendError(err.message);
            return throwError(err);
          case StatusCodes.UNSUPPORTED_MEDIA:
            this.sendError(err.message);
            return throwError(err);
          case StatusCodes.UNPROCESSABLE_CONTENT:
            switch (err.error.message) {
              case ErrorEnum.PRIMARY_ID_EXISTS:
                return throwError(err);
              case ErrorEnum.INN_EXISTS:
                return throwError(err);
              case ErrorEnum.UBKI_IDENT_PHOTO_NOT_CORRECT:
                return throwError(err);
              case ErrorEnum.UBKI_SELFIE_NO_VALID_IDENTITIES:
                return throwError(err);
              default:
                this.toaster.showWithContent(ToastType.WARNING, {
                  title: 'errors.title',
                  message: err.error.message,
                });
                break;
            }
            this.sendError(err.message);
            return throwError(err);
          default:
            this.toaster.showWithContent(ToastType.WARNING, {
              title: 'errors.title',
              message: err.error?.message,
              loggerCode: err.error?.loggerCode,
            });
            this.sendError(err.error?.message);
            return throwError(err);
        }
      }),
    );
  }

  private sendError(error: any) {
    this.eventHelper.send(error, this.sessionStorage.getItem('phone'), 'ERROR');
  }

  // this method may be not optimal (async error response converting), should come up with other decision
  private convertBlobError(blob: Blob): Observable<any> {
    return new Observable<string>((observer) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const responseText = reader.result as string;
        const error = JSON.parse(responseText);
        observer.next(error);
        observer.complete();
      };
      reader.readAsText(blob, 'utf-8');
    });
  }
}
